export default "__VITE_ASSET__DvWYHmx4__"